import styled from 'styled-components';
import CheckOn from 'assets/img/common/ic_check_circle_blue.svg';
import CheckOff from 'assets/img/common/ic_check_circle_gray.svg';

export const AgreementContainer = styled.div`
`;

export const InputCheck = styled.input`
    display: none;
`;

interface LabelContainerProps {
    checked: boolean;
}

export const LabelContainer = styled.div<LabelContainerProps>`
    position: relative;
    display: block;
    padding-left: 40px;
    margin-left: 0px;
        
    &::before{    
        content: '';
        position: absolute;
        top: 2px;
        left: 0px;
        width: 24px;
        height: 24px;
        background-image: url(${props => props.checked ? CheckOn : CheckOff});
        background-size: 24px 24px;
        background-repeat: no-repeat;
        cursor: pointer;
    }
`;

export const LabelWrapper = styled.div`
    > label {
        cursor: pointer;
    }
`;